import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link, NavLink } from 'react-router-dom';
import { Collapse, Navbar, NavbarToggler, Nav, NavItem } from 'reactstrap';
import logo from '../../../assets/images/ng_logo.svg';
import './Header.scss';
import { FormattedMessage } from 'react-intl';

const Header = ({
  page,
  zipcode,
  activePage,
  userLocation,
  language,
  changeLanguage,
}) => {
  const [collapse, setCollapse] = useState(false);

  const isHomepage =
    window.location.pathname === '/' || window.location.pathname === null;

  return (
    <header>
      <div className="Header">
        <div className="container" style={{ padding: 0 }}>
          <Navbar expand="lg">
            <div
              style={{
                paddingTop: '0.75rem',
                paddingBottom: '0.75rem',
              }}
            >
              <Link to="/" className={isHomepage ? 'active' : ''}>
                <img
                  src={logo}
                  className="homepagelogo"
                  alt="{process.env.REACT_APP_FULL_COMPANY_NAME}"
                />
              </Link>
            </div>
            <NavbarToggler onClick={() => setCollapse(!collapse)} />
            <Collapse isOpen={collapse} navbar>
              <Nav navbar>
                <NavItem>
                  <NavLink
                    title={page === 'rates' ? 'Active Page' : null}
                    to="/rates"
                  >
                    <span className="mobile-header-item">
                      <FormattedMessage
                        id="header.rates"
                        defaultMessage="Compare Rates"
                        description="Rates Header"
                      />
                    </span>
                  </NavLink>
                </NavItem>

                <NavItem>
                  <NavLink
                    title={page === 'incentives' ? 'Active Page' : null}
                    to="/incentives"
                  >
                    <span className="mobile-header-item">
                      <FormattedMessage
                        id="header.incentives"
                        defaultMessage="Incentives"
                        description="Incentives Header"
                      />
                    </span>
                  </NavLink>
                </NavItem>
                <NavItem>
                  <Link
                    to="/vehicles"
                    className={
                      activePage === 'vehicles' ||
                      activePage === 'used-vehicles'
                        ? 'active'
                        : ''
                    }
                  >
                    <span className="mobile-header-item">
                      <FormattedMessage
                        id="header.electricVehicles"
                        defaultMessage="Browse EVs"
                        description="Shop Electric Header"
                      />
                    </span>
                  </Link>
                </NavItem>
                <NavItem>
                  <Link
                    to="/compare-vehicles"
                    className={
                      activePage === 'compare-vehicles' ? 'active' : ''
                    }
                  >
                    <span className="mobile-header-item">
                      <FormattedMessage
                        id="header.compareVehicles"
                        defaultMessage="Explore EV Ownership"
                        description="Compare Vehicles Header"
                      />
                    </span>
                  </Link>
                </NavItem>
                <NavItem>
                  <NavLink
                    title={page === 'charging' ? 'Active Page' : null}
                    to="/charging-stations"
                  >
                    <span className="mobile-header-item">
                      <FormattedMessage
                        id="header.chargingStations"
                        defaultMessage="Charging StationsS"
                        description="Charging Stations Header"
                      />
                    </span>
                  </NavLink>
                </NavItem>
              </Nav>
            </Collapse>
          </Navbar>
        </div>
      </div>
    </header>
  );
};

export default Header;

Header.propTypes = {
  page: PropTypes.string,
};
